var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Zoom In"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 335",
    fill: "#fff",
    stroke: "#ece4e4"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h30v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5.5h29v24H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-minus",
    d: "M21 11H9c-.552 0-1 .3-1 .667v.667c0 .368.448.667 1 .667h12c.552 0 1-.3 1-.667v-.667c0-.368-.448-.667-1-.667Z",
    fill: "#376996"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-minus",
    d: "M16 18V6c0-.552-.3-1-.667-1h-.667c-.368 0-.667.448-.667 1v12c0 .552.3 1 .667 1h.667c.368 0 .667-.448.667-1Z",
    fill: "#376996"
  }))));
};
export default SvgZoomIn;